import { createUseStyles } from 'react-jss';
// import Logo from '../assets/images/dai-favicon.png';
import { ReactComponent as DAILogo } from '../assets/icons/dai-logo.svg';
import { useEffect, useState } from 'react';

const time = 3.5;

const useStyles = createUseStyles({
  loadingScreen: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100dvh',
    zIndex: 9999,
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(4px)',
    transition: 'all 0.3s ease-in-out',
  },
  loadingIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  loadingIconInner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  logo: {
    width: '100px',
    height: '100px',
    '& #part1, & #part2, & #part3, & #part4, & #part5, & #part6, & #part7, & #part8, & #part9, & #part10, & #part11, & #part12':
      {
        opacity: 0,
      },
    '& #part1': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '0.1s',
    },
    '& #part2': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '0.2s',
    },
    '& #part3': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '0.3s',
    },
    '& #part4': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '0.4s',
    },
    '& #part5': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '0.5s',
    },
    '& #part6': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '0.6s',
    },
    '& #part7': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '0.7s',
    },
    '& #part8': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '0.8s',
    },
    '& #part9': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '0.9s',
    },
    '& #part10': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '1.0s',
    },
    '& #part11': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '1.1s',
    },
    '& #part12': {
      animation: `$loopFadeInOut ${time}s infinite`,
      animationDelay: '1.2s',
    },
  },
  pulse: {
    animation: '$pulse 1.5s infinite',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(0.95)',
      boxShadow: '0 0 0 0 var(--dai-primary-color)',
    },
    '70%': {
      transform: 'scale(1)',
      boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)',
    },
    '100%': {
      transform: 'scale(0.95)',
      boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
    },
  },
  '@keyframes loopFadeInOut': {
    '0%': {
      opacity: 0,
      transform: 'scale(0.8) translateY(10px)',
    },
    '20%': {
      opacity: 1,
      transform: 'scale(1) translateY(0)',
    },
    '40%': {
      opacity: 1,
      transform: 'scale(1) translateY(0)',
    },
    '60%': {
      opacity: 0,
      transform: 'scale(0.8) translateY(10px)',
    },
    '100%': {
      opacity: 0,
      transform: 'scale(0.8) translateY(10px)',
    },
  },
  fadeIn: {
    opacity: 0,
    animation: '$fadeIn 0.5s forwards',
    animationDelay: '1.5s',
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
});

function LoadingScreen() {
  const classes = useStyles();
  const [showPulse, setShowPulse] = useState(false);

  useEffect(() => {
    // Add pulse effect after initial logo animation
    const timer = setTimeout(() => {
      setShowPulse(true);
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={classes.loadingScreen}>
      <div className={classes.loadingIcon}>
        <div className={classes.loadingIconInner}>
          <DAILogo className={classes.logo} />
          {showPulse && (
            <div
              className={`${classes.pulse} ${classes.fadeIn}`}
              style={{
                position: 'absolute',
                width: '120px',
                height: '120px',
                borderRadius: '50%',
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;
